import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'machine';

const machineService = {
  getMachines: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/machines`,
      data,
    });
  },

  getSingleMachines: (data) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/machines/singleMachines`,
      data,
    });
  },

  createMachine: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateMachine: (data, machineId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(machineId)}`,
      data,
    });
  },

  deleteMachine: (data, machineId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(machineId)}`,
      data,
    });
  },

  orderMachine: (machineId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/orderMachine/${encodeURIComponent(machineId)}`,
      data,
    });
  },

  addResourceToList: (data, id) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/projectResource/${encodeURIComponent(id)}`,
      data,
    });
  },

  deleteResourceFromList: (data, listId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/projectResource/${encodeURIComponent(listId)}`,
      data,
    });
  },

  updateProjectResource: (data, listId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/projectResource/${encodeURIComponent(listId)}`,
      data,
    });
  },
};

export default machineService;
